/*
 * Removes HTML tags from a string
 *
 * @param {string} str The string from which to remove HTML tags
 * @returns {string} The string with no HTML tags
 * */
export default function stripTags(str?: string | null): string {
    const sanitizedStr = str ?? ''

    const STRIP_TAGS_REGEX = /(<([^>]+)>)/gi

    return sanitizedStr.replace(STRIP_TAGS_REGEX, '')
}
